
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/stepperHeader',[
    "Vue",
    "helpers",
    "vuex",
    'vue!./packageSelectionComponent/serviceItemHeader'

  ], function (
    Vue,
    helpers,
    vuex,
    serviceItemHeader
  ) {
    return {
      template: template,
      name: "stepper-header-component",
      props: [],
      components: {
        'service-item-header' : serviceItemHeader
      },
      data: function () {
        return {
          numOfGuestBooking: 0
        }
      },
      computed: _.extend(
        vuex.mapState(['activeStep', 'activeUser', 'currentlyEditingService', 'users', 'afterDeleteData', 'desktopMode', 'loggedInUser', 'bookingProgressPerUser', 'bookForAllGuestCheckBox','usersWithIds']), {
          getServiceName: function () {
            if (this.itemId) {
              return this.users[this.userId][this.itemId].serviceName
            }
          },
          stepperHeaders: function () {
            return _.values(this.localStrings.stepper.header);
          },
          stepperBodyHeaders: function () {
            return _.values(this.localStrings.stepper.body).slice(0, 3);
          },
          userId: function () {
            return Object.keys(this.users)[this.activeUser];
          },
          username:function(){
            return this.usersWithIds[this.userId]
          },
          itemId: function () {
            return Object.keys((this.users[this.userId] || {}))[
              this.currentlyEditingService]
          },
          GetCountOfGuestsPerService: function () {
            var vm = this
            var count = 0;
            _.each(vm.users, function (user) {
              _.values(user).some(function (item) {
                if (item.service && !item.SpaFolioItemId) count++;
              })
            })
            return count
          },
          isServiceBooked: function () {
            var user = _.keys(this.users)[this.activeUser]
            var service = _.keys(this.users[user])[this.currentlyEditingService];
            return !!this.users[user][service].SpaFolioItemId
          },
          bookingProcessShow: function () {
            return this.numOfGuestBooking > 1 && !this.bookForAllGuestCheckBox && !this.isServiceBooked
          },
          recipientName: function () {
            if (this.bookForAllGuestCheckBox) return this.localStrings.stepper.header.bookForAll
            else return this.username
          },
           service: function(){
            return (this.users[this.userId] || {})[this.itemId];
          }
        }),
    watch:{
      activeStep:function(){
          this.numOfGuestBooking = this.GetCountOfGuestsPerService
          this.$store.commit('setBookingProgressPerUser', 1)
      }
    },
    mounted: function () {
        this.numOfGuestBooking = this.GetCountOfGuestsPerService
        this.$store.commit('setBookingProgressPerUser', 1)
      }
    }
  })
})('<div v-if="service"> <service-item-header v-if="activeStep==1 && desktopMode" :recipientName=\'recipientName\' :service="service" :package_item="service.package_item" :white_pill="true" :bottom_margin="true" :active="true" :no_functionality="true" ></service-item-header> <span class="stepper-body-heading " v-if="!desktopMode"> <h1 class="stepper-body-heading-h1" v-if="activeStep==1&& userId"> <span ><label class="stepper-body-heading-editinglabel" v-if="isServiceBooked">{{localization.spaBooking.packageBooking.stepper.header.editText}} </label>{{getServiceName}}</span> <span v-show="loggedInUser" > <label class="stepper-body-heading-h1-label" >For </label> <span>{{" "+ recipientName}}</span> <span v-show="bookingProcessShow"> <label class="stepper-body-heading-h1-label"> ({{bookingProgressPerUser +\' of \'+ numOfGuestBooking}})</label> </span> </span> </h1> </span> </div>');
